// extracted by mini-css-extract-plugin
module.exports = {"className":"textBodyLinkS_className__gkmfD"};